"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  FlipVerticalUp: ['flip-vertical-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.143 6.749L13.547 6.222 14.212 10.669', 'M.75,14.248v7.5a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5v-7.5', 'M0.75 11.248L5.25 11.248', 'M17.25 11.248L23.25 11.248', 'M0.75 6.748L0.75 8.248', 'M23.25 6.748L23.25 8.248', 'M5.25 0.748L6.75 0.748', 'M11.25 0.748L12.75 0.748', 'M17.25 0.748L18.75 0.748', 'M2.25.748a1.5,1.5,0,0,0-1.5,1.5', 'M23.25,2.248a1.5,1.5,0,0,0-1.5-1.5', 'M15,18.364A6.753,6.753,0,0,1,10.5,12a7.2,7.2,0,0,1,3.047-5.776']],
  ReflectUp: ['reflect-up', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.03,6.968l4.94-4.939A.751.751,0,0,0,21.439.748H11.561a.751.751,0,0,0-.531,1.281l4.94,4.939A.749.749,0,0,0,17.03,6.968Z', 'M17.03,17.029l4.94,4.939a.75.75,0,0,1-.531,1.28H11.561a.75.75,0,0,1-.531-1.28l4.94-4.939A.749.749,0,0,1,17.03,17.029Z', 'M23.25 11.998L9.75 11.998', 'M1.5 2.998L6.757 3.696 6.06 8.953', 'M6.75,19.347A7.5,7.5,0,0,1,.75,12,9.031,9.031,0,0,1,6.757,3.7']],
  FlipVerticalDown: ['flip-vertical-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.143 17.248L13.547 17.775 14.212 13.328', 'M.75,9.748v-7.5a1.5,1.5,0,0,1,1.5-1.5h19.5a1.5,1.5,0,0,1,1.5,1.5v7.5', 'M0.75 12.748L5.25 12.748', 'M17.25 12.748L23.25 12.748', 'M0.75 17.248L0.75 15.748', 'M23.25 17.248L23.25 15.748', 'M5.25 23.248L6.75 23.248', 'M11.25 23.248L12.75 23.248', 'M17.25 23.248L18.75 23.248', 'M2.25,23.248a1.5,1.5,0,0,1-1.5-1.5', 'M23.25,21.748a1.5,1.5,0,0,1-1.5,1.5', 'M15,5.633A6.753,6.753,0,0,0,10.5,12a7.2,7.2,0,0,0,3.047,5.777']],
  ReflectDown: ['reflect-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.97,17.029,2.03,21.968a.75.75,0,0,0,.531,1.28h9.878a.75.75,0,0,0,.531-1.28L8.03,17.029A.749.749,0,0,0,6.97,17.029Z', 'M6.97,6.968,2.03,2.029A.751.751,0,0,1,2.561.748h9.878a.751.751,0,0,1,.531,1.281L8.03,6.968A.749.749,0,0,1,6.97,6.968Z', 'M0.75 11.998L14.25 11.998', 'M22.5 20.998L17.243 20.301 17.94 15.044', 'M17.25,4.65a7.5,7.5,0,0,1,6,7.348,9.032,9.032,0,0,1-6.007,8.3']]
};
exports["default"] = _default;